import { memo } from 'react';
import esPlugin from '@ricoh/ria.client.core/plugins/app/es';
import { CustomProvider } from 'rsuite';

import type { RsuiteProviderProps } from './_provider.type';

/** RsuiteProvider. */
export default memo(function RsuiteProvider({ children }: RsuiteProviderProps) {
  return <CustomProvider csp={{ nonce: esPlugin.csp.getNonce() }}>{children}</CustomProvider>;
});
